import { useOutletContext } from 'react-router-dom'
import type { Prompt } from '@/types'

export interface PromptDetailContext {
  prompt: Prompt
  canEdit: boolean
  name: string
  onNameChange: (value: string) => void
  internalName: string
  onInternalNameChange: (value: string) => void
  description: string
  onDescriptionChange: (value: string) => void
  content: string
  onContentChange: (value: string) => void
  validationErrors: Partial<Record<'name' | 'internalName' | 'description' | 'content', string>>
  isDirty: boolean
  isSaving: boolean
  saveBlockedReason: string | null
  onSave: () => void
  onCancel: () => void
}

export function usePromptDetailContext(): PromptDetailContext {
  return useOutletContext<PromptDetailContext>()
}
